<template>
  <div>
    <v-form
      v-model="valid"
      ref="form"
      lazy-validation
      class="pa-4 px-4"
      @submit.prevent="updateSupplier"
      v-if="supplier"
    >
      <v-container>
        <div class="d-flex justify-end">
          <v-btn
            tile
            color="primary"
            @click="$router.push({ name: 'supplier-index' })"
          >
            <v-icon left>
              arrow_back
            </v-icon>
            Back
          </v-btn>
        </div>
        <v-row>
          <v-col offset-md="4" offset-lg="4" md="4" sm="12">
            <image-picker
              v-model="supplier.logo"
              :uploaded="supplier.logo !== null"
              @delete-item="supplier.logo = null"
              @reset="supplier.logo = null"
            >
              <div
                slot="activator"
                class="cursor-pointer w-100 h-100"
                v-if="supplier.logo"
              >
                <img
                  :src="supplier.logo"
                  alt="avatar"
                  width="100%"
                  height="100%"
                />
              </div>
            </image-picker>
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col>
            <v-text-field
              :counter="35"
              label="Name"
              v-model="supplier.name"
              :rules="nameRules"
            ></v-text-field>

            <v-tel-field
              outlined
              label="Phone"
              :rules="phoneRules"
              v-model="supplier.phone"
              required
            ></v-tel-field>

            <v-text-field
              :counter="100"
              label="Address"
              :rules="addressRules"
              v-model="supplier.address"
              required
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              :counter="20"
              label="Apt no"
              v-model="supplier.aptNo"
              :rules="aptRules"
              required
            ></v-text-field>

            <v-text-field
              :counter="25"
              label="State"
              v-model="supplier.state"
              :rules="stateRules"
              required
            ></v-text-field>

            <v-text-field
              :counter="10"
              label="Post Code"
              v-model="supplier.postcode"
              :rules="postCodeRules"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              :counter="20"
              label="City"
              v-model="supplier.city"
              :rules="cityRules"
              required
            ></v-text-field>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="supplier.countryId"
              :items="countries"
              :rules="countryRules"
              filled
              dense
              label="Select Country"
              item-text="name"
              item-value="id"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-checkbox
              v-model="supplier.active"
              label="Is Active"
            ></v-checkbox>
            <v-checkbox
              v-model="supplier.approved"
              label="Is Approved"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-btn type="submit" class="mx-0 mt-4">Update</v-btn>
      </v-container>
    </v-form>
    <order-list module="orders/LOAD_SUPPLIER_ORDERS" :payload="{from:0, to:10, supplierId: id, orderNumber: null, surgeryId: null, paymentStatus: null}" />
    <user-list module="users/LOAD_SUPPLIER_USERS" :payload="{from: 0,to: 10,name: null,approved: null,active: null, supplierId: id}"></user-list>
  </div>
</template>
<script>
import { mapState } from "vuex";
import ImagePicker from "@/components/ImagePicker.vue";
import OrderList from "@/components/order_management/OrderList.vue";
import UserList from "@/components/user_management/UserList.vue";
export default {
  props: ["id"],
  components: {
    ImagePicker,
    OrderList,
    UserList
  },
  data() {
    return {
      valid: false,
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length >= 3) || "Name must be at least 3 characters",
        v => (v && v.length <= 35) || "Name must be less than 35 characters"
      ],
      phoneRules: [
        v => !!v || "Phone is required",
        v => (v && v.length >= 8) || "Phone must be at least 8 digits",
        v => (v && v.length <= 20) || "Phone must be less than 20 digits"
      ],
      addressRules: [
        v => !!v || "Address is required",
        v => (v && v.length >= 3) || "Phone must be at least 3 character",
        v => (v && v.length <= 100) || "Phone must be less than 100 characters"
      ],
      aptRules: [
        v => !!v || "Apt no is required",
        v => (v && v.length >= 3) || "Apt no must be at least 3 character",
        v => (v && v.length <= 20) || "Apt no must be less than 20 characters"
      ],
      stateRules: [
        v => !!v || "State is required",
        v => (v && v.length >= 3) || "Name must be at least 3 characters",
        v => (v && v.length <= 25) || "Name must be less than 25 characters"
      ],
      postCodeRules: [
        v => !!v || "PostCode is required",
        v => (v && v.length >= 5) || "PostCode must be at least 5 characters",
        v => (v && v.length <= 10) || "PostCode must be less than 10 characters"
      ],
      cityRules: [
        v => !!v || "City is required",
        v => (v && v.length >= 3) || "City must be at least 3 characters",
        v => (v && v.length <= 35) || "City must be less than 35 characters"
      ],
      countryRules: [v => !!v || "Country is required"]
    };
  },
  mounted() {
    this.$store.dispatch("suppliers/LOAD_SUPPLIER", {
      supplierId: this.id
    });
    this.$store.dispatch("countries/LOAD_COUNTRIES", {
      from: 0,
      to: 0
    });
  },
  computed: {
    ...mapState({
      countries: state => state.countries.countries,
      supplier: state => state.suppliers.supplier
    })
  },
  methods: {
    async updateSupplier() {
      if (this.$refs.form.validate()) {
        this.$swal({
          title: "Updating supplier...",
          html: "this will only take a moment...",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("suppliers/UPDATE_SUPPLIER", this.supplier);
        this.$swal.close();
        this.$swal({
          title: "Success",
          html: "Supplier has been updated",
          icon: "info"
        });
      }
    }
  }
};
</script>
